module.exports = __webpack_public_path__ + "static/media/2025.206665d0.png";